import { type ConversationAssistantConfig } from '@atlassian/conversation-assistant-widget/types';

import { type AppConfig } from '../types';

export const appConfig = process.env.appConfig as unknown as AppConfig;

export const getAppConfig = (): AppConfig => {
	return appConfig;
};

export const getEnvConfig = (): ConversationAssistantConfig => {
	return (
		(appConfig.dbAgentConfig as ConversationAssistantConfig) ??
		(appConfig.config as ConversationAssistantConfig)
	);
};
